import Vue from 'vue';
import App from './App.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
require('@/assets/styles/manusa.css');
require('@/assets/styles/efirma.css');

import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_HOSTPYAPI;
// axios.defaults.baseURL =
//   process.env.NODE_ENV !== "production"
//     ? process.env.VUE_APP_API_MANUSA_DEV
//     : process.env.VUE_APP_API_MANUSA_PROD;

const queryString = window.location.search;
var hayCargaInicial = false;
if (queryString) {
  //se obtiene el token del queryString
  const TOKEN = queryString.split('token=')[1].split('&')[0];
  if (TOKEN != '') {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('usuario');

    //se almacena el token el session del navegador
    sessionStorage.setItem('token', TOKEN);
    // se actualiza el valor del Token en Vuex
    store.dispatch('user/setToken', TOKEN);
    // se piden los datos del usuario para cargar en Vuex
    // // store.dispatch('user/getUser')
    cargarDatosUsuarioSegunToken(TOKEN, true);
    hayCargaInicial = true;
  }
}

// Si no hay sesión guardada, se redirige a la página principal
if (!sessionStorage.getItem('token') || !sessionStorage.getItem('usuario')) router.replace('/').catch(() => {});

function cargarDatosUsuarioSegunToken(token, redirigirHome) {
  axios
    .post(
      'efirma/accion',
      {
        accion: 'getusuario'
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then((res) => {
      console.log('cargarDatosUsuarioSegunToken', res.data);
      if (!res.data.error) {
        store.dispatch('user/setUser', res.data.usuario);

        //Se obtienen las tipologías diponibles en base a los permisos del usuario
        let tipologiasDeBusqueda = [];
        let tipologiasDeEFirma = [];
        let arr;
        res.data.usuario.permisos.forEach((p) => {
          if (p.tipologias[0] == '*') {
            arr = res.data.tipologiasdepartamentos.filter((td) => td.departamento == p.departamento);
            if (arr.length) {
              tipologiasDeBusqueda = tipologiasDeBusqueda.concat(arr);
              if (p.acceso == 'READWRITE') tipologiasDeEFirma = tipologiasDeEFirma.concat(arr);
            }
          } else {
            // en caso de indicar tipos concretos, por cada uno se añadirá al array correspondiente
            p.tipologias.forEach((pt) => {
              arr = res.data.tipologiasdepartamentos.filter((td) => td.codigo == pt);
              if (arr.length) {
                tipologiasDeBusqueda = tipologiasDeBusqueda.concat(arr);
                if (p.acceso == 'READWRITE') tipologiasDeEFirma = tipologiasDeEFirma.concat(arr);
              }
            });
          }
        });
        const misTipologias = {
          busqueda: tipologiasDeBusqueda,
          efirma: tipologiasDeEFirma
        };
        console.log('misTipologias', misTipologias);

        // se añade el nuevo item a la información del usuario
        res.data.usuario['tipologias'] = misTipologias;

        // se guarda en el sesión el objeto final
        sessionStorage.setItem('usuario', JSON.stringify(res.data.usuario));

        // si se ha indicado redirigir a Home, se lleva a cabo
        if (redirigirHome) router.replace('/').catch(() => {});
      } else {
        sessionStorage.removeItem('usuario');
        alert('ERROR - ' + res.data.error.message);
        router.replace('/').catch(() => {});
      }
      ////console.log(this.getters)
    })
    .catch(function (error) {
      console.log('ERROR', error);
      store.dispatch('user/setUser', null);
    })
    .then(function () {
      // always executed
    });
}

setInterval(() => {
  cargarDatosUsuarioSegunToken(sessionStorage.getItem('token'), false);
  store.dispatch('user/setToken', sessionStorage.getItem('token'));
  store.dispatch('user/setUser', JSON.parse(sessionStorage.getItem('usuario')));
}, 300000);

// al inicio, se carga la información contenida en sesion en el Vuex
// si ha habido carga inicial, se da un tiempo de 1s para que se almacenen los datos en sessionstorage
setTimeout(
  () => {
    store.dispatch('user/setToken', sessionStorage.getItem('token'));
    store.dispatch('user/setUser', JSON.parse(sessionStorage.getItem('usuario')));
    new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app');
  },
  hayCargaInicial ? 1000 : 0
);
